import { EditOverview } from '@features/ForestOwner/EditShareOwnership/editOverview'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/forestowner/$forestownerId/shareownership/editShareOwnership/',
)({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Endre andelsinformasjon',
  },
})

function RouteComponent() {
  return <EditOverview />
}
